import React from 'react';
import { useOutletContext } from 'react-router-dom';
import NotificationManagement from '../../components/Admin/Notification/NotificationManagement';

const AdminNotifications = () => {
  const { setIsLoading } = useOutletContext();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Gestion des notifications
        </h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Gérez les notifications envoyées aux utilisateurs
        </p>
      </div>
      
      <NotificationManagement setIsLoading={setIsLoading} />
    </div>
  );
};

export default AdminNotifications; 